<div class="search-filter">
    <span class="filter-label" *ngIf="filterSelection.length > 0">Filter</span>

    <ng-template #billPeriod>
        <div class="filter-item filter-sltStatus">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #billPeriodDropdown aria-label="billPeriod" [(ngModel)]="date" placeholder="Bill Period"
                    (selectionChange)="handleApplyFilter(date, 'date')" disableOptionCentering
                    panelClass="filter-select-menu no-search region">
                    <span class="select-label">Bill Period</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of billPeriodOptions" [value]="x">{{x}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #sltStatus>
        <div class="filter-item filter-sltStatus">
            <mat-form-field class="select-menu sltStatus" appearance="outline" floatLabel="always">
                <mat-select class="selectSltStatus" #sSLT aria-label="sltStatus" [(ngModel)]="selectSltStatusValue"
                    placeholder="SLT Status" (selectionChange)="handleApplyFilter(selectSltStatusValue, 'slt status')"
                    disableOptionCentering panelClass="filter-select-menu no-search sltStatus">
                    <span class="select-label">SLT Status</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let type of customerTypeOptions"
                            [value]="type.key">{{type.value}}</mat-option>
                    </div>
                    <!-- <button class="btn btn-apply" (click)="handleApplyFilter(selectSltStatusValue, 'slt status'); sSLT.close()">Apply</button> -->
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #region>
        <div class="filter-item filter-district" *ngIf="!districtId">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sRegion aria-label="region" [(ngModel)]="selectRegionValue"
                    (selectionChange)="handleApplyFilter(selectRegionValue, 'region')" placeholder="Region"
                    disableOptionCentering panelClass="filter-select-menu region">
                    <span class="select-label">Region</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let region of regionOptions"
                            [value]="region.key">{{region.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #district>
        <div class="filter-item filter-district" *ngIf="!districtId">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sDistrict aria-label="district" [(ngModel)]="selectDistrictValue"
                    (selectionChange)="handleApplyFilter(selectDistrictValue, 'district')" placeholder="District"
                    disableOptionCentering panelClass="filter-select-menu region" [disabled]="disableDistrictSelect">
                    <span class="select-label">District</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let district of districtOptions"
                            [value]="district.key">{{district.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #route>
        <div class="filter-item filter-district">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sDistrict aria-label="district" [(ngModel)]="selectRouteValue"
                    (selectionChange)="handleApplyFilter(selectRouteValue, 'route')" placeholder="Route"
                    disableOptionCentering panelClass="filter-select-menu region" [disabled]="disableRouteSelect">
                    <span class="select-label">Route</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let route of routeOptions" [value]="route.key">{{route.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #itineary>
        <div class="filter-item filter-itinerary">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sDistrict aria-label="district" [(ngModel)]="selectItineraryValue"
                    (selectionChange)="handleApplyFilter(selectItineraryValue, 'itinerary')" placeholder="Itinerary"
                    disableOptionCentering panelClass="filter-select-menu region" [disabled]="disableItinerarySelect">
                    <span class="select-label">Itinerary</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let itinerary of itineraryOptions"
                            [value]="itinerary.key">{{itinerary.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #readType>
        <div class="filter-item filter-readType">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sReadType aria-label="readType" [(ngModel)]="selectReadTypeValue" placeholder="Read Type"
                    disableOptionCentering panelClass="filter-select-menu no-search" multiple>
                    <span class="select-label">Read Type</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let readType of readTypeOptions"
                            [value]="readType.key">{{readType.value}}</mat-option>
                    </div>
                    <button class="btn btn-apply"
                        (click)="handleApplyFilter(selectReadTypeValue, 'read type'); sReadType.close()">Apply</button>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #validationStatus>
        <div class="filter-item filter-contractStatus">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #vStatus aria-label="contractStatus" [(ngModel)]="selectValidationStatusValue"
                    placeholder="Validation Status" disableOptionCentering panelClass="filter-select-menu no-search"
                    multiple>
                    <span class="select-label">Validation Status</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of validationStatusOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                    <button class="btn btn-apply"
                        (click)="handleApplyFilter(selectValidationStatusValue, 'validation status'); vStatus.close()">Apply</button>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #failedValidationStatus>
        <div class="filter-item filter-district">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sStatus aria-label="status" [(ngModel)]="selectFailedValidationStatusValue"
                    (selectionChange)="handleApplyFilter(selectFailedValidationStatusValue, 'status')"
                    placeholder="Status" disableOptionCentering panelClass="filter-select-menu region">
                    <span class="select-label">Status</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let status of failedValidationStatusOptions"
                            [value]="[status.key]">{{status.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #meterMake>
        <div class="filter-item filter-meterMake">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sMeter aria-label="meterMake" [(ngModel)]="selectMeterMakeValue" placeholder="Meter make"
                    disableOptionCentering panelClass="filter-select-menu no-search" multiple>
                    <span class="select-label">Meter make</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let meter of meterMakeOptions"
                            [value]="meter.key">{{meter.value}}</mat-option>
                    </div>
                    <button class="btn btn-apply"
                        (click)="handleApplyFilter(selectMeterMakeValue, 'meter make'); sMeter.close()">Apply</button>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #meterPhase>
        <div class="filter-item filter-connectionType">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #sType aria-label="connection Type" [(ngModel)]="selectConnectionTypeValue"
                    placeholder="Meter Phase" disableOptionCentering panelClass="filter-select-menu no-search" multiple>
                    <span class="select-label">Meter Phase</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let type of connectionTypeOptions"
                            [value]="type.key">{{type.value}}</mat-option>
                    </div>
                    <button class="btn btn-apply"
                        (click)="handleApplyFilter(selectConnectionTypeValue, 'connection type'); sType.close()">Apply</button>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #billStatus>
        <div class="filter-item filter-sltStatus">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #billStatus aria-label="sltStatus" [(ngModel)]="selectBillStatus"
                    (selectionChange)="handleApplyFilter(selectBillStatus, 'bill status')" placeholder="Bill Status"
                    disableOptionCentering panelClass="filter-select-menu no-search billStatus">
                    <span class="select-label">Bill Status</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of billStatusOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #email>
        <div class="filter-item filter-district">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #emailFilter aria-label="emailFilter" [(ngModel)]="selectEmailValue"
                    (selectionChange)="handleApplyFilter(selectEmailValue, 'email')" placeholder="Email"
                    disableOptionCentering panelClass="filter-select-menu no-search region">
                    <span class="select-label">Email</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of emailOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #auditDescription>
        <div class="filter-item filter-district">
            <app-single-select-dropdown
                [elements]="auditDescriptionOptions"
                [preselectedOption]="selectedAuditDescription"
                [dropdownType]="'with-header'"
                [menuAllign]="'left'"
                [isOptionBorderVisible]="true"
                [placeholderText]="'Audit Description'"
                [dropdownMenuMinWidth]="'200px'"
                [dropdownMenuMaxHeight]="'250px'"
                [dropdownWidth]="'16.5rem'"
                [dropdownHeight]="'39px'"
                [dropdownMinWidth]="'auto'"
                (selectionChanged)="auditDescriptionChanged($event)" />
          </div>
    </ng-template>

    <ng-template #auditTrailAction>
        <div class="filter-item filter-district">
            <app-single-select-dropdown
                [elements]="auditTrailActions"
                [preselectedOption]="selectedAuditTrailAction"
                [dropdownType]="'with-header'"
                [menuAllign]="'left'"
                [isOptionBorderVisible]="true"
                [placeholderText]="'Action Taken'"
                [dropdownMenuMinWidth]="'200px'"
                [dropdownMenuMaxHeight]="'250px'"
                [dropdownWidth]="'16.5rem'"
                [dropdownHeight]="'39px'"
                [dropdownMinWidth]="'auto'"
                (selectionChanged)="auditTrailChanged($event)" />
          </div>
    </ng-template>

    <ng-template #meterType>
        <div class="filter-item filter-meter-type">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #meterTypeFilter aria-label="meterTypeFilter" [(ngModel)]="selectMeterTypeValue"
                    (selectionChange)="handleApplyFilter(selectMeterTypeValue, 'meter type')" placeholder="Meter Type"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Meter Type</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of meterTypeOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #minimumBalance>
        <div class="filter-item filter-minimum-balance">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #minimumBalanceFilter aria-label="minimumBalanceFilter" [(ngModel)]="selectMinimumBalanceValue"
                    (selectionChange)="handleApplyFilter(selectMinimumBalanceValue, 'minimum balance')" placeholder="Minimum Balance"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Minimum Balance</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of minimumBalanceOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>
    
    <ng-template #consumption>
        <div class="filter-item filter-consumption">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #consumptionFilter aria-label="consumptionFilter" [(ngModel)]="selectConsumptionValue"
                    (selectionChange)="handleApplyFilter(selectConsumptionValue, 'consumption')" placeholder="Consumption"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Consumption</span>
                    <div class="option-wrapper">
                        <mat-option [value]="0">Positive</mat-option>
                        <mat-option [value]="1">Negative</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #fraudType>
        <div class="filter-item filter-contractStatus">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #fraudTypeFilter aria-label="fraudTypeFilter" [(ngModel)]="selectFraudTypeValue"
                    (selectionChange)="handleApplyFilter(selectFraudTypeValue, 'fraud type')" placeholder="Recovery Type"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Recovery Type</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of fraudTypeOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #eventType>
        <div class="filter-item filter-eventType">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #eventTypeFilter aria-label="eventTypeFilter" [(ngModel)]="selectEventTypeValue"
                    (selectionChange)="handleApplyFilter(selectEventTypeValue, 'event type')" placeholder="Event Type"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Event Type</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of eventTypeOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #dateRange>
        <div class="filter-item filter-date">
            <button class="select-menu date-menu" [matMenuTriggerFor]="menu">
                <span>Date</span>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="filter-select-menu date-select-menu no-search">
                <span class="select-label">Date</span>
                <div class="date date-from">
                    <span>From</span>
                    <mat-form-field appearance="fill">
                        <input placeholder="dd-mm-yyyy" matInput [matDatepicker]="picker1" [value]="dateFrom" autocomplete="off"
                            (dateChange)="onDate($event, 'dateFrom')">
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="date date-to">
                    <span>To</span>
                    <mat-form-field appearance="fill">
                        <input placeholder="dd-mm-yyyy" matInput [matDatepicker]="picker2" [value]="dateTo" autocomplete="off"
                            (dateChange)="onDate($event, 'dateTo')">
                        <mat-datepicker-toggle matSuffix [for]="picker2">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
                <button class="btn btn-apply" (click)="handleApplyFilter(null, 'date')">Apply</button>
            </mat-menu>
        </div>
    </ng-template>

    <ng-template #dueDate>
        <div class="filter-item filter-date">
            <button class="date-menu" [matMenuTriggerFor]="menu">
                <span>Due Date</span>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="filter-select-menu date-select-menu no-search">
                <span class="select-label">Due Date</span>
                <div class="date date-from">
                    <span>From</span>
                    <mat-form-field appearance="fill">
                        <input placeholder="dd-mm-yyyy" matInput [matDatepicker]="picker1" [value]="dateFrom" autocomplete="off"
                            (dateChange)="onDate($event, 'dateFrom')">
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="date date-to">
                    <span>To</span>
                    <mat-form-field appearance="fill">
                        <input placeholder="dd-mm-yyyy" matInput [matDatepicker]="picker2" [value]="dateTo" autocomplete="off"
                            (dateChange)="onDate($event, 'dateTo')">
                        <mat-datepicker-toggle matSuffix [for]="picker2">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
                <button class="btn btn-apply" (click)="handleApplyFilter(null, 'date')">Apply</button>
            </mat-menu>
        </div>
    </ng-template>

    <ng-template #jobTitle>
        <div class="filter-item filter-sltStatus">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #billPeriodDropdown aria-label="billPeriod" [(ngModel)]="selectJobTitleValue"
                    placeholder="Job title" (selectionChange)="handleApplyFilter(selectJobTitleValue, 'jobTitle')"
                    disableOptionCentering panelClass="filter-select-menu no-search region">
                    <span class="select-label">Job Title</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of jobTitleOptions" [value]="x">{{x}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #fraudStatus>
        <div class="filter-item filter-sltStatus">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #fraudStatus aria-label="fraudStatus" [(ngModel)]="selectFraudStatus"
                    (selectionChange)="handleApplyFilter(selectFraudStatus, 'Fraud Status')" placeholder="Status"
                    disableOptionCentering panelClass="filter-select-menu no-search billStatus">
                    <span class="select-label">Status</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of fraudStatusOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #isEstimated>
        <div class="filter-item filter-contractStatus">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #vStatus aria-label="contractStatus" [(ngModel)]="selectIsEstimated"
                    placeholder="Estimation Status" disableOptionCentering panelClass="filter-select-menu no-search" 
                    (selectionChange)="handleApplyFilter(selectIsEstimated, 'estimation status')">
                    <span class="select-label">Estimation Status</span>
                    <div class="option-wrapper">
                        <mat-option [value]="1">Estimated</mat-option>
                        <mat-option [value]="0">Actual</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #group>
        <div class="filter-item filter-sltStatus">
            <app-single-select-dropdown
                [elements]="groupOptions"
                [preselectedOption]="selectedGroup"
                [dropdownType]="'with-header'"
                [menuAllign]="'left'"
                [isOptionBorderVisible]="true"
                [placeholderText]="'Group'"
                [dropdownMenuMinWidth]="'200px'"
                [dropdownMenuMaxHeight]="'200px'"
                [dropdownHeight]="'39px'"
                (selectionChanged)="accountGroupChanged($event)" />
        </div>
    </ng-template>

    <ng-template #tariff>
        <div class="filter-item filter-sltStatus">
            <app-single-select-dropdown
                [elements]="tariffOptions"
                [preselectedOption]="selectedTariff"
                [dropdownType]="'with-header'"
                [menuAllign]="'left'"
                [isOptionBorderVisible]="true"
                [placeholderText]="'Tariff'"
                [dropdownMenuMinWidth]="'200px'"
                [dropdownMenuMaxHeight]="'200px'"
                [dropdownHeight]="'39px'"
                (selectionChanged)="tariffChanged($event)" />
        </div>
    </ng-template>

    <ng-template #districtPrepay>
        <div class="filter-item filter-sltStatus">
            <app-single-select-dropdown
                [elements]="districtOptionsPrepay"
                [preselectedOption]="selectedDistrictPrepay"
                [dropdownType]="'with-header'"
                [menuAllign]="'left'"
                [isOptionBorderVisible]="true"
                [placeholderText]="'District'"
                [dropdownMenuMinWidth]="'200px'"
                [dropdownMenuMaxHeight]="'200px'"
                [dropdownHeight]="'39px'"
                (selectionChanged)="districtPrepayChanged($event)" />
        </div>
    </ng-template>

    <ng-template #meterMakePrepay>
        <div class="filter-item filter-sltStatus">
            <app-single-select-dropdown
                [elements]="meterMakeOptionsPrepay"
                [preselectedOption]="selectedMeterMakePrepay"
                [dropdownType]="'with-header'"
                [menuAllign]="'left'"
                [isOptionBorderVisible]="true"
                [placeholderText]="'Meter Make'"
                [dropdownMenuMinWidth]="'200px'"
                [dropdownMenuMaxHeight]="'200px'"
                [dropdownHeight]="'39px'"
                (selectionChanged)="meterMakePrepayChanged($event)" />
        </div>
    </ng-template>

    <ng-template #customerActivityType>
        <div class="filter-item filter-customer-activiry-type">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #customerActivityTypeFilter aria-label="customerActivityTypeFilter" [(ngModel)]="selectCustomerActivityTypeValue"
                    (selectionChange)="handleApplyFilter(selectCustomerActivityTypeValue, 'customer activity type')" placeholder="Customer Activity Type"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Customer Activity Type</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of customerActivityTypeOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #debtAging>
        <div class="filter-item filter-meter-type">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #debtAgingFilter aria-label="debtAgingFilter" [(ngModel)]="selectDebtAgingValue"
                    (selectionChange)="handleApplyFilter(selectDebtAgingValue, 'debt aging')" placeholder="Debt aging"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Debt Aging by Days</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of debtAgingOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-template #accountType>
        <div class="filter-item filter-customer-activiry-type">
            <mat-form-field class="select-menu" appearance="outline" floatLabel="always">
                <mat-select #accountTypeFilter aria-label="accountTypeFilter" [(ngModel)]="selectAccountTypeValue"
                    (selectionChange)="handleApplyFilter(selectAccountTypeValue, 'account type')" placeholder="Account Type"
                    disableOptionCentering panelClass="filter-select-menu no-search">
                    <span class="select-label">Account Type</span>
                    <div class="option-wrapper">
                        <mat-option *ngFor="let x of accountTypeOptions" [value]="x.key">{{x.value}}</mat-option>
                    </div>
                </mat-select>
                <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-template>

    <ng-container *ngFor="let container of this.filterSelection">
        <ng-container [ngSwitch]="container">
            <ng-container *ngSwitchCase="'billPeriod'">
                <ng-container *ngTemplateOutlet="billPeriod"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'sltStatus'">
                <ng-container *ngTemplateOutlet="sltStatus"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'region'">
                <ng-container *ngTemplateOutlet="region"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'district'">
                <ng-container *ngTemplateOutlet="district"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'route'">
                <ng-container *ngTemplateOutlet="route"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'itineary'">
                <ng-container *ngTemplateOutlet="itineary"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'readType'">
                <ng-container *ngTemplateOutlet="readType"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'validationStatus'">
                <ng-container *ngTemplateOutlet="validationStatus"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'failedValidationStatus'">
                <ng-container *ngTemplateOutlet="failedValidationStatus"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'meterMake'">
                <ng-container *ngTemplateOutlet="meterMake"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'meterPhase'">
                <ng-container *ngTemplateOutlet="meterPhase"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'billStatus'">
                <ng-container *ngTemplateOutlet="billStatus"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'email'">
                <ng-container *ngTemplateOutlet="email"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'dateRange'">
                <ng-container *ngTemplateOutlet="dateRange"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'dueDate'">
                <ng-container *ngTemplateOutlet="dueDate"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'jobTitle'">
                <ng-container *ngTemplateOutlet="jobTitle"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'fraudStatus'">
                <ng-container *ngTemplateOutlet="fraudStatus"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'auditDescription'">
                <ng-container *ngTemplateOutlet="auditDescription"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'auditTrailAction'">
                <ng-container *ngTemplateOutlet="auditTrailAction"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'group'">
                <ng-container *ngTemplateOutlet="group"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'isEstimated'">
                <ng-container *ngTemplateOutlet="isEstimated"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'meterType'">
                <ng-container *ngTemplateOutlet="meterType"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'minimumBalance'">
                <ng-container *ngTemplateOutlet="minimumBalance"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'consumption'">
                <ng-container *ngTemplateOutlet="consumption"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'tariff'">
                <ng-container *ngTemplateOutlet="tariff"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'districtPrepay'">
                <ng-container *ngTemplateOutlet="districtPrepay"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'meterMakePrepay'">
                <ng-container *ngTemplateOutlet="meterMakePrepay"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'fraudType'">
                <ng-container *ngTemplateOutlet="fraudType"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'eventType'">
                <ng-container *ngTemplateOutlet="eventType"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'customerActivityType'">
                <ng-container *ngTemplateOutlet="customerActivityType"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'debtAging'">
                <ng-container *ngTemplateOutlet="debtAging"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'accountType'">
                <ng-container *ngTemplateOutlet="accountType"></ng-container>
            </ng-container>
        </ng-container>

    </ng-container>

    <div class="search-filter-wrapper" *ngIf="showSearch">
        <input (keydown)="catchEnter($event)" type="text" [(ngModel)]="searchInput" [placeholder]="searchPlaceholder" autocomplete="off">
        <button class="search-button" (click)="this.onFilterChange()">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0916 16.9085L15 13.8418C16.2001 12.3455 16.7812 10.4462 16.624 8.53458C16.4667 6.62292 15.583 4.84415 14.1546 3.56403C12.7261 2.28392 10.8615 1.59976 8.94408 1.65222C7.02668 1.70469 5.20225 2.4898 3.84593 3.84612C2.48962 5.20243 1.70451 7.02686 1.65204 8.94427C1.59957 10.8617 2.28374 12.7263 3.56385 14.1548C4.84397 15.5832 6.62273 16.4669 8.5344 16.6242C10.4461 16.7814 12.3453 16.2002 13.8416 15.0002L16.9083 18.0668C16.9858 18.1449 17.078 18.2069 17.1795 18.2492C17.281 18.2915 17.39 18.3133 17.5 18.3133C17.61 18.3133 17.7189 18.2915 17.8205 18.2492C17.922 18.2069 18.0142 18.1449 18.0916 18.0668C18.2418 17.9114 18.3258 17.7038 18.3258 17.4877C18.3258 17.2716 18.2418 17.0639 18.0916 16.9085ZM9.16665 15.0002C8.01292 15.0002 6.88511 14.658 5.92582 14.0171C4.96653 13.3761 4.21886 12.4651 3.77735 11.3992C3.33584 10.3333 3.22032 9.16036 3.4454 8.0288C3.67048 6.89725 4.22605 5.85785 5.04186 5.04204C5.85766 4.22624 6.89707 3.67066 8.02862 3.44558C9.16018 3.2205 10.3331 3.33602 11.399 3.77753C12.4649 4.21904 13.3759 4.96672 14.0169 5.926C14.6579 6.88529 15 8.01311 15 9.16683C15 10.7139 14.3854 12.1977 13.2914 13.2916C12.1975 14.3856 10.7137 15.0002 9.16665 15.0002Z"
                    fill="white" />
            </svg>
        </button>
    </div>
</div>

<div class="active-filters-wrapper"
    *ngIf="appliedFilters.length > 0 || (date != '' && dateApplied) || (dateFrom != '' && dateTo != '' && dateApplied)">
    <div class="filters">
        <div class="item" *ngIf="date != '' && dateApplied">
            <span class="label">Date: </span>
            <span class="name">{{date}}</span>
            <span class="remove-filter-btn" (click)="handleRemoveFilter('date')">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.2924 10.9998L16.2341 7.06734C16.4067 6.89473 16.5037 6.66062 16.5037 6.41651C16.5037 6.1724 16.4067 5.93829 16.2341 5.76568C16.0615 5.59307 15.8274 5.49609 15.5833 5.49609C15.3392 5.49609 15.1051 5.59307 14.9324 5.76568L10.9999 9.70734L7.06744 5.76568C6.89483 5.59307 6.66072 5.49609 6.41661 5.49609C6.1725 5.49609 5.93839 5.59307 5.76578 5.76568C5.59317 5.93829 5.49619 6.1724 5.49619 6.41651C5.49619 6.66062 5.59317 6.89473 5.76578 7.06734L9.70744 10.9998L5.76578 14.9323C5.67986 15.0176 5.61167 15.1189 5.56513 15.2306C5.51859 15.3424 5.49463 15.4622 5.49463 15.5832C5.49463 15.7042 5.51859 15.824 5.56513 15.9357C5.61167 16.0474 5.67986 16.1488 5.76578 16.234C5.85099 16.3199 5.95238 16.3881 6.06408 16.4347C6.17579 16.4812 6.2956 16.5052 6.41661 16.5052C6.53762 16.5052 6.65744 16.4812 6.76914 16.4347C6.88084 16.3881 6.98223 16.3199 7.06744 16.234L10.9999 12.2923L14.9324 16.234C15.0177 16.3199 15.119 16.3881 15.2307 16.4347C15.3425 16.4812 15.4623 16.5052 15.5833 16.5052C15.7043 16.5052 15.8241 16.4812 15.9358 16.4347C16.0475 16.3881 16.1489 16.3199 16.2341 16.234C16.32 16.1488 16.3882 16.0474 16.4348 15.9357C16.4813 15.824 16.5053 15.7042 16.5053 15.5832C16.5053 15.4622 16.4813 15.3424 16.4348 15.2306C16.3882 15.1189 16.32 15.0176 16.2341 14.9323L12.2924 10.9998Z"
                        fill="white" />
                </svg>
            </span>
        </div>
        <div class="item" *ngIf="dateFrom != '' && dateTo != '' && dateApplied">
            <span class="label">Date: </span>
            <span class="name">{{from}} - {{to}}</span>
            <span class="remove-filter-btn" (click)="handleRemoveFilter('dateRange')">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.2924 10.9998L16.2341 7.06734C16.4067 6.89473 16.5037 6.66062 16.5037 6.41651C16.5037 6.1724 16.4067 5.93829 16.2341 5.76568C16.0615 5.59307 15.8274 5.49609 15.5833 5.49609C15.3392 5.49609 15.1051 5.59307 14.9324 5.76568L10.9999 9.70734L7.06744 5.76568C6.89483 5.59307 6.66072 5.49609 6.41661 5.49609C6.1725 5.49609 5.93839 5.59307 5.76578 5.76568C5.59317 5.93829 5.49619 6.1724 5.49619 6.41651C5.49619 6.66062 5.59317 6.89473 5.76578 7.06734L9.70744 10.9998L5.76578 14.9323C5.67986 15.0176 5.61167 15.1189 5.56513 15.2306C5.51859 15.3424 5.49463 15.4622 5.49463 15.5832C5.49463 15.7042 5.51859 15.824 5.56513 15.9357C5.61167 16.0474 5.67986 16.1488 5.76578 16.234C5.85099 16.3199 5.95238 16.3881 6.06408 16.4347C6.17579 16.4812 6.2956 16.5052 6.41661 16.5052C6.53762 16.5052 6.65744 16.4812 6.76914 16.4347C6.88084 16.3881 6.98223 16.3199 7.06744 16.234L10.9999 12.2923L14.9324 16.234C15.0177 16.3199 15.119 16.3881 15.2307 16.4347C15.3425 16.4812 15.4623 16.5052 15.5833 16.5052C15.7043 16.5052 15.8241 16.4812 15.9358 16.4347C16.0475 16.3881 16.1489 16.3199 16.2341 16.234C16.32 16.1488 16.3882 16.0474 16.4348 15.9357C16.4813 15.824 16.5053 15.7042 16.5053 15.5832C16.5053 15.4622 16.4813 15.3424 16.4348 15.2306C16.3882 15.1189 16.32 15.0176 16.2341 14.9323L12.2924 10.9998Z"
                        fill="white" />
                </svg>
            </span>
        </div>
        <div class="item" *ngFor="let filter of appliedFilters">
            <span class="label">{{filter.name | titlecase}}: </span>
            <span class="name" *ngFor="let val of filter.value; let isLast=last">{{getAppliedFilterName(val,
                filter.name)}}{{isLast ? '' : ', '}}</span>
            <span class="remove-filter-btn" (click)="handleRemoveFilter(filter.name)">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.2924 10.9998L16.2341 7.06734C16.4067 6.89473 16.5037 6.66062 16.5037 6.41651C16.5037 6.1724 16.4067 5.93829 16.2341 5.76568C16.0615 5.59307 15.8274 5.49609 15.5833 5.49609C15.3392 5.49609 15.1051 5.59307 14.9324 5.76568L10.9999 9.70734L7.06744 5.76568C6.89483 5.59307 6.66072 5.49609 6.41661 5.49609C6.1725 5.49609 5.93839 5.59307 5.76578 5.76568C5.59317 5.93829 5.49619 6.1724 5.49619 6.41651C5.49619 6.66062 5.59317 6.89473 5.76578 7.06734L9.70744 10.9998L5.76578 14.9323C5.67986 15.0176 5.61167 15.1189 5.56513 15.2306C5.51859 15.3424 5.49463 15.4622 5.49463 15.5832C5.49463 15.7042 5.51859 15.824 5.56513 15.9357C5.61167 16.0474 5.67986 16.1488 5.76578 16.234C5.85099 16.3199 5.95238 16.3881 6.06408 16.4347C6.17579 16.4812 6.2956 16.5052 6.41661 16.5052C6.53762 16.5052 6.65744 16.4812 6.76914 16.4347C6.88084 16.3881 6.98223 16.3199 7.06744 16.234L10.9999 12.2923L14.9324 16.234C15.0177 16.3199 15.119 16.3881 15.2307 16.4347C15.3425 16.4812 15.4623 16.5052 15.5833 16.5052C15.7043 16.5052 15.8241 16.4812 15.9358 16.4347C16.0475 16.3881 16.1489 16.3199 16.2341 16.234C16.32 16.1488 16.3882 16.0474 16.4348 15.9357C16.4813 15.824 16.5053 15.7042 16.5053 15.5832C16.5053 15.4622 16.4813 15.3424 16.4348 15.2306C16.3882 15.1189 16.32 15.0176 16.2341 14.9323L12.2924 10.9998Z"
                        fill="white" />
                </svg>
            </span>
        </div>
    </div>
    <button class="clear-all" (click)="clearAllFilters()">
        <span>Clear All</span>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.2925 10.9998L16.2342 7.06734C16.4068 6.89473 16.5038 6.66062 16.5038 6.41651C16.5038 6.1724 16.4068 5.93829 16.2342 5.76568C16.0616 5.59307 15.8274 5.49609 15.5833 5.49609C15.3392 5.49609 15.1051 5.59307 14.9325 5.76568L11 9.70734L7.06751 5.76568C6.89489 5.59307 6.66078 5.49609 6.41667 5.49609C6.17256 5.49609 5.93845 5.59307 5.76584 5.76568C5.59323 5.93829 5.49625 6.1724 5.49625 6.41651C5.49625 6.66062 5.59323 6.89473 5.76584 7.06734L9.70751 10.9998L5.76584 14.9323C5.67992 15.0176 5.61173 15.1189 5.56519 15.2306C5.51865 15.3424 5.49469 15.4622 5.49469 15.5832C5.49469 15.7042 5.51865 15.824 5.56519 15.9357C5.61173 16.0474 5.67992 16.1488 5.76584 16.234C5.85105 16.3199 5.95244 16.3881 6.06414 16.4347C6.17585 16.4812 6.29566 16.5052 6.41667 16.5052C6.53768 16.5052 6.6575 16.4812 6.7692 16.4347C6.8809 16.3881 6.98229 16.3199 7.06751 16.234L11 12.2923L14.9325 16.234C15.0177 16.3199 15.1191 16.3881 15.2308 16.4347C15.3425 16.4812 15.4623 16.5052 15.5833 16.5052C15.7044 16.5052 15.8242 16.4812 15.9359 16.4347C16.0476 16.3881 16.149 16.3199 16.2342 16.234C16.3201 16.1488 16.3883 16.0474 16.4348 15.9357C16.4814 15.824 16.5053 15.7042 16.5053 15.5832C16.5053 15.4622 16.4814 15.3424 16.4348 15.2306C16.3883 15.1189 16.3201 15.0176 16.2342 14.9323L12.2925 10.9998Z"
                fill="#C03438" />
        </svg>
    </button>
</div>